import Component from '../inherited/Component'

export default class SelectURL extends Component {
  constructor (elem, theme, options, ctx) {
    super(elem, theme, options, ctx)
  }

  mount () {
    let active = this._elem.querySelector('.radiant-pages-nav__link--active')

    if (active) {
      this._elem.scrollLeft = active.offsetLeft - parseFloat(getComputedStyle(this._elem).marginLeft)
    }
  }
}